var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGraphUp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 51,
    viewBox: "0 0 98 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M97 1.20068C81.4031 2.50043 80.4372 33.6171 65 37.2007C52.2702 40.1558 45.8241 23.381 33 25.2007C19.0903 27.1744 14.6391 44.6543 1 49.2007H97V1.20068Z",
    fill: "#ECFDF3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M97 1.20068C81.4031 2.50043 80.4372 33.6171 65 37.2007C52.2702 40.1558 45.8241 23.381 33 25.2007C19.0903 27.1744 14.6391 44.6543 1 49.2007H97V1.20068Z",
    fill: "url(#paint0_linear_1589_120)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 49.2007C14.6391 44.6543 19.0903 27.1744 33 25.2007C45.8241 23.381 52.2702 40.1558 65 37.2007C80.4372 33.6171 81.4031 2.50043 97 1.20068",
    stroke: "#12B76A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1589_120",
    x1: 49,
    y1: 1.20068,
    x2: 49,
    y2: 49.2007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.641167,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F9FC"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphUp);
export default __webpack_public_path__ + "static/media/graph-up.4776172ba77396843db09f5e5d64039f.svg";
export { ForwardRef as ReactComponent };